import {Injectable} from '@angular/core';
import {IStorage} from '../interfaces';
import {STORAGE} from '../enums/storage';
import {WebStorageService} from './webStorage';

@Injectable()
export class SessionStorageService extends WebStorageService implements IStorage {
	constructor() {
		super(STORAGE.session);
	}
}



// WEBPACK FOOTER //
// ./src/services/jng2-webstorage/services/sessionStorage.ts